/* ========================================================================
 * Apricot's Data Module
 * ======================================================================== */

// json
import CBData from "../api/CBData";

export default CBData;
